<formio-loader></formio-loader>
<div class="card mainBranch panel" *ngIf="showMainBranch" [ngClass]="{'disable' : !showMainBranch.hasMainBransh}">
    <div class="content">
        <h4>{{'forms.common.' + showMainBranch.label | translate}}</h4>
        <div class="row" *ngIf="showMainBranch.hasMainBransh">
            <div class="col-sm-6" *ngFor="let item of showMainBranch.fields">
                <i class="{{item.icon}}" [style.color]="item.color || '#000'"></i>

                <span *ngIf="item.type == 'date';else normal">
                    {{item.value ? (item.value | date : 'yyyy-MM-dd') : ('forms.common.inicatorsNoData' | translate)}}
                </span>
                <ng-template #normal>
                    <span>{{item.value ? item.value : ('forms.common.inicatorsNoData' | translate)}}</span>
                </ng-template>
            </div>
        </div>
        <div *ngIf="!showMainBranch.hasMainBransh" class="noDataContainer">
            <span>{{'forms.common.Main branch data has not yet been entered' | translate}}</span>
        </div>
        <span class="notes" *ngIf="showMainBranch.messageError && !showMainBranch.hasMainBransh">
            {{'forms.common.' + showMainBranch.messageError | translate}}
        </span>
    </div>
</div>

<div fxLayout="row" [max]="60" fxLayoutAlign="end stretch" style="height:100%" appSplit="row">
    <div fxFlex="{{modifyInDialog ? 100 : 40}}" [fxFlex.sm]="modifyInDialog ? 100 : 50" [fxFlex.xs]="100"
        [fxHide.xs]="windowProperties.open" [fxHide]="windowProperties.fullscreen" appSplitArea
        class="resizeable-pane list-pane spliterContaienr">
        <div *ngIf="!viewOnly" class="tree-header">
            <button type="button" (click)="createDialog(true,customOptions)" *ngIf="name"
                class="btn btn-primary btn-md">
                {{'forms.common.Add' | translate}} {{ 'forms.common.' + name | translate}}</button>

            <!-- <button type="button" (click)="removeBulk()" *ngIf="checklistSelection.hasValue()" class="delete-selection"
                color="primary" mat-button>
                <mat-icon class="action delete">delete</mat-icon>
                {{'forms.common.Delete Selected Items' | translate}}
            </button> -->
        </div>
        <i class="fas fa-code-branch"></i>
        <br *ngIf="!viewOnly" />
        <br *ngIf="!viewOnly" />
        <div class="input-group tree-filter" *ngIf="treeSource.data.length">
            <div class="input-group-prepend tree-group">
                <span class="input-group-text">
                    <span class="fa fa-filter" aria-hidden="true"></span>
                </span>
            </div>
            <input class="form-control" name="filter" placeholder="{{'forms.common.keyword' | translate}}"
                (input)="filterUpdate.next($any($event.target).value)" [(ngModel)]="filterKeyword" />
        </div>
        <mat-tree *ngIf="dir && filteredTreeSource.data.length" [dataSource]="filteredTreeSource" [trackBy]="trackBy"
            [treeControl]="treeControl" [dir]="dir">
            <mat-tree-node *matTreeNodeDef="let node" class="leave" matTreeNodeToggle>
                <li class="mat-tree-node" renderDebug>
                    <div class="center-content">
                        <button disabled mat-icon-button></button>
                        <!-- <mat-checkbox (change)="todoLeafItemSelectionToggle(node)" *ngIf="!viewOnly && !node.isMain"
                            [checked]="checklistSelection.isSelected(node)">
                            <span [innerHTML]="node.name | safeHtml"></span>
                        </mat-checkbox>
                        <span *ngIf="viewOnly || node.isMain" [innerHTML]="node.name | safeHtml"></span> -->
                        <span class="item-name" [innerHTML]="node.name | safeHtml"></span>
                    </div>

                    <div class="actions">
                        <span *ngIf="!viewOnly">
                            <ng-container *ngFor="let btn of node.actions">
                                <mat-icon (click)="createNode(node,btn.bindWith)" *ngIf="btn.name == 'action'"
                                    [matTooltipPosition]="'above'"
                                    [matTooltip]="('forms.common.Add' | translate) +' '+ ('forms.common.' + btn.bindWith | translate)"
                                    class="action add">add
                                </mat-icon>
                            </ng-container>
                        </span>
                        <mat-icon (click)="viewDialog(node)" class="action view">visibility</mat-icon>
                        <mat-icon (click)="editDialog(node)" *ngIf="!viewOnly && hasAction(node,'edit')"
                            class="action edit">
                            edit
                        </mat-icon>
                        <mat-icon (click)="removeNode(node)" *ngIf="!viewOnly && hasAction(node,'delete')"
                            class="action delete" [ngClass]="{'disable-icon' : node.isMain}">delete
                        </mat-icon>

                    </div>
                </li>
            </mat-tree-node>
            <mat-nested-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                <li class="mat-tree-node" renderDebug>
                    <div class="center-content mat-tree-node">
                        <button [attr.aria-label]="'Toggle ' + node.name" mat-icon-button matTreeNodeToggle>
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <!-- <mat-checkbox (change)="todoItemSelectionToggle(node)" *ngIf="!viewOnly && !node.isMain"
                            [checked]="checklistSelection.isSelected(node)"
                            [indeterminate]="descendantsPartiallySelected(node)">
                            <span [innerHTML]="node.name | safeHtml"></span>
                        </mat-checkbox>
                        <span *ngIf="viewOnly|| node.isMain" [innerHTML]="node.name | safeHtml"></span> -->
                        <span class="item-name" [innerHTML]="node.name | safeHtml"></span>
                    </div>
                    <div class="actions">
                        <span *ngIf="!viewOnly">
                            <ng-container *ngFor="let btn of node.actions">
                                <mat-icon (click)="createNode(node,btn.bindWith)" *ngIf="btn.name == 'action'"
                                    [matTooltipPosition]="'above'"
                                    [matTooltip]="('forms.common.Add' | translate) +' '+ ('forms.common.' + btn.bindWith | translate)"
                                    class="action add">add
                                </mat-icon>
                            </ng-container>
                        </span>

                        <mat-icon (click)="viewDialog(node)" class="action view">visibility</mat-icon>
                        <mat-icon (click)="editDialog(node)" *ngIf="!viewOnly && hasAction(node,'edit')"
                            class="action edit">
                            edit
                        </mat-icon>
                        <mat-icon (click)="removeNode(node)" *ngIf="!viewOnly && hasAction(node,'delete')"
                            class="action delete" [ngClass]="{'disable-icon' : node.isMain}">delete
                        </mat-icon>
                    </div>
                </li>
                <ul [class.children-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </mat-nested-tree-node>
        </mat-tree>
    </div>
    <ng-container *ngIf="!modifyInDialog">
        <div [hidden]="windowProperties.fullscreen" class="handle hide-xs spliterIcon" appSplitHandle>
            <mat-icon>drag_indicator</mat-icon>
        </div>
        <div [fxFlex]="60" [fxFlex.sm]="50" [fxFlex.xs]="100" [fxHide.xs]="!windowProperties.open"
            [ngClass]="{'fullscreen': windowProperties.fullscreen}" appSplitArea
            class="resizeable-pane spliterContaienr">
            <add-edit-dialog *ngIf="activeNodeData" [data]="activeNodeData" (close)="closeActive($event)">
            </add-edit-dialog>
        </div>
    </ng-container>
</div>